var _circle, _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyProductMob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 246,
    viewBox: "0 0 246 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 123,
    r: 123,
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 246,
    height: 246
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 123,
    r: 123,
    fill: "url(#paint1_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.2451,
    y: 53.2615,
    width: 173,
    height: 194.274,
    rx: 1.93237,
    transform: "rotate(-0.0805182 36.2451 53.2615)",
    fill: "black"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.2451,
    y: 53.2615,
    width: 173,
    height: 194.274,
    rx: 1.93237,
    transform: "rotate(-0.0805182 36.2451 53.2615)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2483 55.2734C36.2468 54.2062 37.1108 53.3398 38.178 53.3383L207.313 53.1007C208.381 53.0992 209.247 53.9631 209.249 55.0303L209.26 63.1101L36.2597 63.3532L36.2483 55.2734Z",
    fill: "#646B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9558 61.3025C47.338 61.3005 48.4569 60.1784 48.455 58.7962C48.4531 57.414 47.331 56.2951 45.9488 56.297C44.5665 56.299 43.4476 57.421 43.4496 58.8033C43.4515 60.1855 44.5736 61.3044 45.9558 61.3025Z",
    fill: "#4E5465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4024 61.3025C55.7847 61.3005 56.9036 60.1784 56.9016 58.7962C56.8997 57.414 55.7776 56.2951 54.3954 56.297C53.0132 56.299 51.8943 57.421 51.8962 58.8033C51.8982 60.1855 53.0202 61.3044 54.4024 61.3025Z",
    fill: "#AAAFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5362 61.3025C63.9184 61.3005 65.0374 60.1784 65.0354 58.7962C65.0335 57.414 63.9114 56.2951 62.5292 56.297C61.147 56.299 60.0281 57.421 60.03 58.8033C60.0319 60.1855 61.154 61.3044 62.5362 61.3025Z",
    fill: "#AAAFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.8365,
    y: 77.1157,
    width: 128.178,
    height: 62.1603,
    rx: 1.28824,
    transform: "rotate(-0.0805182 57.8365 77.1157)",
    fill: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.56 185.538C103.559 184.827 104.135 184.249 104.847 184.248L140.144 184.199C140.855 184.198 141.433 184.774 141.434 185.485L141.483 220.782C141.484 221.494 140.908 222.071 140.197 222.072L104.9 222.122C104.188 222.123 103.611 221.547 103.61 220.835L103.56 185.538ZM59.2678 185.603C59.2668 184.891 59.8428 184.314 60.5542 184.313L95.8512 184.263C96.5627 184.262 97.1403 184.838 97.1413 185.55L97.1909 220.847C97.1919 221.558 96.6159 222.136 95.9045 222.137L60.6075 222.186C59.896 222.187 59.3184 221.611 59.3174 220.9L59.2678 185.603ZM149.461 184.186C148.749 184.187 148.173 184.765 148.174 185.476L148.224 220.773C148.225 221.485 148.802 222.061 149.514 222.06L184.811 222.01C185.522 222.009 186.098 221.432 186.097 220.72L186.048 185.423C186.047 184.712 185.469 184.136 184.758 184.137L149.461 184.186Z",
    fill: "#E1E5F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.1447,
    y: 143.261,
    width: 78.6366,
    height: 6.29472,
    rx: 3.14736,
    transform: "rotate(-0.0805182 58.1447 143.261)",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.1589,
    y: 153.49,
    width: 70.7729,
    height: 6.29472,
    rx: 3.14736,
    transform: "rotate(-0.0805182 58.1589 153.49)",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.174,
    y: 163.72,
    width: 62.9092,
    height: 6.29472,
    rx: 3.14736,
    transform: "rotate(-0.0805182 58.174 163.72)",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.002,
    y: 143.138,
    width: 39.3183,
    height: 12.5894,
    rx: 1,
    transform: "rotate(-0.0805182 147.002 143.138)",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.615,
    y: 225.333,
    width: 32.7381,
    height: 5.1354,
    rx: 2.5677,
    transform: "rotate(-0.0805182 103.615 225.333)",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.629,
    y: 234,
    width: 19.5787,
    height: 5.1354,
    rx: 2.5677,
    transform: "rotate(-0.0805182 103.629 234)",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.3236,
    y: 225.396,
    width: 32.7381,
    height: 5.1354,
    rx: 2.5677,
    transform: "rotate(-0.0805182 59.3236 225.396)",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.3352,
    y: 234.062,
    width: 19.5787,
    height: 5.1354,
    rx: 2.5677,
    transform: "rotate(-0.0805182 59.3352 234.062)",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.798 225.268C149.38 225.27 148.232 226.421 148.234 227.839C148.236 229.258 149.387 230.406 150.805 230.404L178.087 230.365C179.505 230.363 180.653 229.212 180.651 227.794C180.649 226.376 179.498 225.228 178.079 225.23L150.798 225.268ZM150.809 233.934C149.391 233.936 148.243 235.087 148.245 236.505C148.247 237.923 149.398 239.071 150.816 239.069L165.259 239.049C166.677 239.047 167.825 237.896 167.823 236.478C167.821 235.059 166.67 233.911 165.252 233.913L150.809 233.934Z",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.254 100.228L139.254 121.775L103.342 121.775L103.342 100.228L121.299 89.4546L139.254 100.228Z",
    fill: "#4165FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.254 100.228L139.254 121.775L121.298 121.775L121.298 89.4546L139.254 100.228Z",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7079 100.228L103.342 89.4543L121.298 89.4543L116.664 100.228L98.7079 100.228Z",
    fill: "#6380FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.888 100.228L139.254 89.4543L121.298 89.4543L125.932 100.228L143.888 100.228Z",
    fill: "#2F56FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.114 112.746L112.013 112.746L112.013 115.644L109.114 115.644L109.114 112.746Z",
    fill: "#5273FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.749 118.373C145.749 123.271 141.778 127.241 136.881 127.241C131.982 127.241 128.012 123.271 128.012 118.373C128.012 113.475 131.982 109.504 136.881 109.504C141.778 109.504 145.749 113.475 145.749 118.373Z",
    fill: "#1EB27A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.714 119.714V124H136.286V119.714H132V118.286H136.286V114H137.714V118.286H142V119.714H137.714Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -107.755,
    y: -86.9817,
    width: 461.273,
    height: 482.516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 72
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 123,
    y1: 0,
    x2: 123,
    y2: 246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 123,
    y1: 0,
    x2: 123,
    y2: 246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProductMob);
export default __webpack_public_path__ + "static/media/empty-product-mob.c7dc2002d890714bae31ebf6fed14547.svg";
export { ForwardRef as ReactComponent };